export class MyWorkService {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    /**
     * The full hub payload. counts_only skips item assembly for cheap badge
     * polling.
     *
     * `location_id` scopes the WORK-ORDER group ONLY (omit = no WO group). It
     * does not touch the timesheets group: a timesheet belongs to a person and
     * a pay period, never to a location — that group is bounded by who the
     * caller may see, and its items carry the locations each person worked at
     * as context.
     */
    async getMyWork(input) {
        const params = { account_id: input.account_id };
        if (input.location_id)
            params.location_id = input.location_id;
        if (input.counts_only)
            params.counts_only = 'true';
        return this.apiClient.get('/me/work', params);
    }
}
